// eslint-disable-next-line no-unused-vars
var AbilityTranslator = {
    "No Ability": "0",
    "Adaptability": "91",
    "Aerilate": "184",
    "Aftermath": "106",
    "Air Lock": "76",
    "Analytic": "148",
    "Anger Point": "83",
    "Anger Shell": "271",
    "Anticipation": "107",
    "Arena Trap": "71",
    "Armor Tail": "296",
    "Aroma Veil": "165",
    "As One (Glastrier)": "266",
    "As One (Spectrier)": "267",
    "Aura Break": "188",
    "Bad Dreams": "123",
    "Ball Fetch": "237",
    "Battery": "217",
    "Battle Armor": "4",
    "Battle Bond": "210",
    "Beads of Ruin": "287",
    "Beast Boost": "224",
    "Berserk": "201",
    "Big Pecks": "145",
    "Blaze": "66",
    "Bulletproof": "171",
    "Cheek Pouch": "167",
    "Chilling Neigh": "264",
    "Chlorophyll": "34",
    "Clear Body": "29",
    "Cloud Nine": "13",
    "Color Change": "16",
    "Comatose": "213",
    "Commander": "279",
    "Competitive": "172",
    "Compound Eyes": "14",
    "Contrary": "126",
    "Corrosion": "212",
    "Costar": "294",
    "Cotton Down": "238",
    "Cud Chew": "291",
    "Curious Medicine": "261",
    "Cursed Body": "130",
    "Cute Charm": "56",
    "Damp": "6",
    "Dancer": "216",
    "Dark Aura": "186",
    "Dauntless Shield": "235",
    "Dazzling": "219",
    "Defeatist": "129",
    "Defiant": "128",
    "Delta Stream": "191",
    "Desolate Land": "190",
    "Disguise": "209",
    "Download": "88",
    "Dragon's Maw": "263",
    "Drizzle": "2",
    "Drought": "70",
    "Dry Skin": "87",
    "Early Bird": "48",
    "Earth Eater": "297",
    "Effect Spore": "27",
    "Electric Surge": "226",
    "Electromorphosis": "280",
    "Embody Aspect (Cornerstone)": "304",
    "Embody Aspect (Hearthflame)": "303",
    "Embody Aspect (Teal)": "301",
    "Embody Aspect (Wellspring)": "302",
    "Emergency Exit": "194",
    "Fairy Aura": "187",
    "Filter": "111",
    "Flame Body": "49",
    "Flare Boost": "138",
    "Flash Fire": "18",
    "Flower Gift": "122",
    "Flower Veil": "166",
    "Fluffy": "218",
    "Forecast": "59",
    "Forewarn": "108",
    "Friend Guard": "132",
    "Frisk": "119",
    "Full Metal Body": "230",
    "Fur Coat": "169",
    "Gale Wings": "177",
    "Galvanize": "206",
    "Gluttony": "82",
    "Good as Gold": "283",
    "Gooey": "183",
    "Gorilla Tactics": "255",
    "Grass Pelt": "179",
    "Grassy Surge": "229",
    "Grim Neigh": "265",
    "Guard Dog": "275",
    "Gulp Missile": "241",
    "Guts": "62",
    "Hadron Engine": "289",
    "Harvest": "139",
    "Healer": "131",
    "Heatproof": "85",
    "Heavy Metal": "134",
    "Honey Gather": "118",
    "Hospitality": "299",
    "Huge Power": "37",
    "Hunger Switch": "258",
    "Hustle": "55",
    "Hydration": "93",
    "Hyper Cutter": "52",
    "Ice Body": "115",
    "Ice Face": "248",
    "Ice Scales": "246",
    "Illuminate": "35",
    "Illusion": "149",
    "Immunity": "17",
    "Imposter": "150",
    "Infiltrator": "151",
    "Innards Out": "215",
    "Inner Focus": "39",
    "Insomnia": "15",
    "Intimidate": "22",
    "Intrepid Sword": "234",
    "Iron Barbs": "160",
    "Iron Fist": "89",
    "Justified": "154",
    "Keen Eye": "51",
    "Klutz": "103",
    "Leaf Guard": "102",
    "Levitate": "26",
    "Libero": "236",
    "Light Metal": "135",
    "Lightning Rod": "31",
    "Limber": "7",
    "Lingering Aroma": "268",
    "Liquid Ooze": "64",
    "Liquid Voice": "204",
    "Long Reach": "203",
    "Magic Bounce": "156",
    "Magic Guard": "98",
    "Magician": "170",
    "Magma Armor": "40",
    "Magnet Pull": "42",
    "Marvel Scale": "63",
    "Mega Launcher": "178",
    "Merciless": "196",
    "Mimicry": "250",
    "Mind's Eye": "300",
    "Minus": "58",
    "Mirror Armor": "240",
    "Misty Surge": "228",
    "Mold Breaker": "104",
    "Moody": "141",
    "Motor Drive": "78",
    "Moxie": "153",
    "Multiscale": "136",
    "Multitype": "121",
    "Mummy": "152",
    "Mycelium Might": "298",
    "Natural Cure": "30",
    "Neuroforce": "233",
    "Neutralizing Gas": "256",
    "No Guard": "99",
    "Normalize": "96",
    "Oblivious": "12",
    "Opportunist": "290",
    "Orichalcum Pulse": "288",
    "Overcoat": "142",
    "Overgrow": "65",
    "Own Tempo": "20",
    "Parental Bond": "185",
    "Pastel Veil": "257",
    "Perish Body": "253",
    "Pickpocket": "124",
    "Pickup": "53",
    "Pixilate": "182",
    "Plus": "57",
    "Poison Heal": "90",
    "Poison Point": "38",
    "Poison Puppeteer": "310",
    "Poison Touch": "143",
    "Power Construct": "211",
    "Power of Alchemy": "223",
    "Power Spot": "249",
    "Prankster": "158",
    "Pressure": "46",
    "Primordial Sea": "189",
    "Prism Armor": "232",
    "Propeller Tail": "239",
    "Protean": "168",
    "Protosynthesis": "281",
    "Psychic Surge": "227",
    "Punk Rock": "244",
    "Pure Power": "74",
    "Purifying Salt": "272",
    "Quark Drive": "282",
    "Queenly Majesty": "214",
    "Quick Draw": "259",
    "Quick Feet": "95",
    "Rain Dish": "44",
    "Rattled": "155",
    "Receiver": "222",
    "Reckless": "120",
    "Refrigerate": "174",
    "Regenerator": "144",
    "Ripen": "247",
    "Rivalry": "79",
    "RKS System": "225",
    "Rock Head": "69",
    "Rocky Payload": "276",
    "Rough Skin": "24",
    "Run Away": "50",
    "Sand Force": "159",
    "Sand Rush": "146",
    "Sand Spit": "245",
    "Sand Stream": "45",
    "Sand Veil": "8",
    "Sap Sipper": "157",
    "Schooling": "208",
    "Scrappy": "113",
    "Screen Cleaner": "251",
    "Seed Sower": "269",
    "Serene Grace": "32",
    "Shadow Shield": "231",
    "Shadow Tag": "23",
    "Sharpness": "292",
    "Shed Skin": "61",
    "Sheer Force": "125",
    "Shell Armor": "75",
    "Shield Dust": "19",
    "Shields Down": "197",
    "Simple": "86",
    "Skill Link": "92",
    "Slow Start": "112",
    "Slush Rush": "202",
    "Sniper": "97",
    "Snow Cloak": "81",
    "Snow Warning": "117",
    "Solar Power": "94",
    "Solid Rock": "116",
    "Soul-Heart": "220",
    "Soundproof": "43",
    "Speed Boost": "3",
    "Stakeout": "198",
    "Stall": "100",
    "Stalwart": "242",
    "Stamina": "192",
    "Stance Change": "176",
    "Static": "9",
    "Steadfast": "80",
    "Steam Engine": "243",
    "Steelworker": "200",
    "Steely Spirit": "252",
    "Stench": "1",
    "Sticky Hold": "60",
    "Storm Drain": "114",
    "Strong Jaw": "173",
    "Sturdy": "5",
    "Suction Cups": "21",
    "Super Luck": "105",
    "Supersweet Syrup": "306",
    "Supreme Overlord": "293",
    "Surge Surfer": "207",
    "Swarm": "68",
    "Sweet Veil": "175",
    "Swift Swim": "33",
    "Symbiosis": "180",
    "Synchronize": "28",
    "Sword of Ruin": "285",
    "Tablets of Ruin": "286",
    "Tangled Feet": "77",
    "Tangling Hair": "221",
    "Technician": "101",
    "Telepathy": "140",
    "Teraform Zero": "309",
    "Tera Shell": "308",
    "Tera Shift": "307",
    "Teravolt": "164",
    "Thermal Exchange": "270",
    "Thick Fat": "47",
    "Tinted Lens": "110",
    "Torrent": "67",
    "Tough Claws": "181",
    "Toxic Boost": "137",
    "Toxic Chain": "305",
    "Toxic Debris": "295",
    "Trace": "36",
    "Transistor": "262",
    "Triage": "205",
    "Truant": "54",
    "Turboblaze": "163",
    "Unaware": "109",
    "Unburden": "84",
    "Unnerve": "127",
    "Unseen Fist": "260",
    "Vessel of Ruin": "284",
    "Victory Star": "162",
    "Vital Spirit": "72",
    "Volt Absorb": "10",
    "Wandering Spirit": "254",
    "Water Absorb": "11",
    "Water Bubble": "199",
    "Water Compaction": "195",
    "Water Veil": "41",
    "Weak Armor": "133",
    "Well-Baked Body": "273",
    "White Smoke": "73",
    "Wimp Out": "193",
    "Wind Power": "277",
    "Wind Rider": "274",
    "Wonder Guard": "25",
    "Wonder Skin": "147",
    "Zen Mode": "161",
    "Zero to Hero": "278",
    "Mountaineer": "-2",
    "Rebound": "-3",
    "Persistent": "-4"
}
export default AbilityTranslator;